// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isLeapYear/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isLeapYear = convertToFP(fn, 1);
export default isLeapYear;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isLeapYear/index.js
// module id = 927
// module chunks = 0